var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutMainPages',[(_vm.isLoading)?_c('Loading'):_c('div',{staticClass:"mr-s48 w-full xl:mr-0"},[_c('AccountDeletionMessage',_vm._b({},'AccountDeletionMessage',_vm.message,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }